
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    TimeSlotModal
} from './timeslotsmodal';

export const timeslotsathenastate = (
    context: any,
    initial?:TimeSlotModal[],
) => {
    const initValue = initial || [];

    return (
        state: TimeSlotModal[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};

